import React from 'react'
import injectSheet from 'react-jss'
import styles from './auth.styles'
import Logo from './logo'
import classNames from 'classnames'

const Auth = ({ classes, children, className }) => (
  <div className={classNames(classes.container, className)}>
    <div className={classes.holder}>
      <a href="../" aria-label="Go back to Pobble" className={classes.logo}>
        <Logo color="#253488" secondaryColor="#00a1e9" />
      </a>
      {children}
    </div>
  </div>
)

export default injectSheet(styles)(Auth)
